import React, { useEffect, useMemo } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import classNames from 'classnames';
import Scrollbar from 'react-scrollbars-custom';
import { compilationScrollbarSettings } from '../../../constants/copyright';
import { types } from '../../../constants/modalConstructor';
import { useModal } from '../../../hooks/useModal';
import { useTranslation } from '../../../translations';

const WModal = React.forwardRef(function WModal(
  { type = 'level', mod, func, selection, gameType, modalProps, onCloseCallbacks, giftsBalance, ...props },
  ref,
) {
  const { closeModal, id } = useModal();
  const { t } = useTranslation();

  const propsWithTranslations = useMemo(() => {
    const result = {
      ...props,
      title: t(props.title),
      description: type == 'level' ? t(props.description, { lvl: props.lvl }) : t(props.description),
      noteValue: `${t(props.noteValue)} ${giftsBalance || ''}`,
    };
    if (props.titleData) {
      result.titleData = Object.entries(props.titleData).reduce((acc, [key, value]) => {
        acc[key] = t(value);
        return acc;
      }, {});
    }
    return result;
  }, [props, t]);

  const isSelection = selection?.list?.length > 0;

  const close = () => {
    func?.();
    closeModal({ id });
  };

  useEffect(() => {
    ({
      level: onCloseCallbacks?.level,
    })[type]?.();
  }, []);

  return (
    <CustomModal {...(modalProps ? modalProps : {})}>
      <div
        className={classNames(`w-modal`, {
          'w-modal_scroll': isSelection,
          'w-modal_selection': isSelection,
          [`w-modal_${mod}`]: mod,
          [`w-modal_${type}`]: type,
        })}
        ref={ref}
      >
        <div className='w-modal__bg' onClick={close} />
        <div className='w-modal__content'>
          {isSelection ? (
            <Scrollbar {...compilationScrollbarSettings}>
              {getContent(type, { ...propsWithTranslations, selection })}
            </Scrollbar>
          ) : (
            getContent(type, { ...propsWithTranslations, selection }, close)
          )}
        </div>
      </div>
    </CustomModal>
  );
});

export default WModal;
WModal.propTypes = {};

function getContent(type, props, close) {
  return types[type]?.content
    .map(({ getContext, Component }, id) => {
      const context = getContext(props);
      return context ? <Component key={`el-${id}`} {...context} type={type} close={close} /> : null;
    })
    .filter((child) => child);
}
